import React from 'react';
import { X, CheckCircle } from 'lucide-react';

const IndustryModal = ({ isOpen, onClose, industry, image }) => {
  if (!isOpen || !industry) return null;

  const features = [
    'Custom design solutions tailored to industry needs',
    'Expert team with years of domain experience',
    'Cost-effective and efficient project delivery',
    'Compliance with industry standards and regulations',
    'Ongoing support and maintenance services'
  ];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="modal-industry-content">
          <div className="modal-industry-image">
            <img src={image} alt={industry.name} />
            <div className="modal-industry-overlay"></div>
          </div>

          <div className="modal-industry-details">
            <h2 className="heading-2 text-primary mb-4">{industry.name}</h2>
            <p className="body-large text-text-secondary mb-6">
              {industry.description}
            </p>

            <h3 className="heading-5 text-primary mb-4">What We Offer</h3>
            <ul className="industry-features-list">
              {features.map((feature, idx) => (
                <li key={idx} className="industry-feature-item">
                  <CheckCircle size={20} className="feature-check" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <div className="modal-cta">
              <button className="btn-primary btn-glow" onClick={onClose}>
                Learn More About Our Services
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustryModal;